import { try_on } from 'feature/widget/TryOnStore'
import { action, makeAutoObservable } from 'mobx'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { api } from 'store/api'
import { mx } from 'store/base/mx'
import { CLOSE } from 'store/base/mx/MxRef'
import { Client, Customer, saveClient } from 'type/client'

export const LAST_TIME = false

const widget_user_ids = new Map<string, string>()

export class UserStore {
  readonly company: string
  readonly employee_id: string
  readonly data: Customer
  widget_user_id: string | null = null
  last_time: number | null = null

  constructor(company: string, employee_id: string, data: Client) {
    this.company = company
    this.employee_id = employee_id
    this.data = { ...data, company }
    this.widget_user_id = widget_user_ids.get(data.user_id) || null
    makeAutoObservable(this)
    saveClient(this.employee_id, this.data)
    void this.widget()
  }

  [CLOSE]() {
    saveClient(this.employee_id, undefined)
  }

  get user_id(): string {
    return this.data.user_id
  }

  fav() {
    void try_on.fav()
  }

  private async widget() {
    const manager_id = employee.manager_id
    await try_on.boutique(this.user_id, manager_id)

    try_on.onUpdate(action((event) => {
      const { user_id: widget_user_id, picture, last_time } = event
      const { user_id } = this
      this.widget_user_id = widget_user_id || null
      if (widget_user_id) widget_user_ids.set(this.data.user_id, widget_user_id)
      else widget_user_ids.delete(this.data.user_id)
      if (picture && picture !== this.data.picture) {
        this.data.picture = picture
        void api.updateUser({ user_id, picture })
        saveClient(this.employee_id, this.data)
      }
      if (LAST_TIME) this.last_time = last_time || null
    }))
  }
}

export const user = mx.ref<UserStore>()
